import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowUpward = (props) => {
    const { color } = props;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M1 15C0.447716 15 0 14.5523 0 14V1C0 0.447715 0.447715 0 1 0H14C14.5523 0 15 0.447715 15 0.999999C15 1.55228 14.5523 2 14 2L3.41406 2L15.7077 14.2936C16.0982 14.6841 16.0982 15.3173 15.7077 15.7078C15.3171 16.0983 14.684 16.0983 14.2935 15.7078L2 3.41436L2 14C2 14.5523 1.55229 15 1 15Z" }));
};
export default factorySvgIcon(SvgArrowUpward);
//# sourceMappingURL=SvgArrowUpward.js.map